$(document).ready(function() {

    var showMap = true;

    if ($("#mapInner").length && showMap === true) {
        GetECInnerMap();
    } else {
        $("#mapInner").hide();
    }

    if ($("#mapRight").length && showMap === true) {
        GetECMiniMap();
    } else {
        $("#mapRight").hide();
        if ($("#grosseKarte").length) {
            $("#grosseKarte").hide();
        }
    }

    if ($("#ttgMapTab").length && showMap === true) {
        // Deprecated (MAPS)
        //GetECMiniMapTab();
    } else {
        $("#ttgMapTab").hide();
    }

    if ($("#ttgTeaserMap").length && showMap === true) {
        var ttgTeaserMapIframeSrc = $("#ttgTeaserMap iframe").attr("src");
        $("#ttgTeaserMap iframe").attr("src", ttgTeaserMapIframeSrc + "&d=" + Date.now());
        // Deprecated (MAPS)
        //GetECTeaserMap();
    } else {
        $("#ttgTeaserMap").hide();
        if ($("#ttgTeaserMapOuter").length) {
            $("#ttgTeaserMapOuter").hide();
        }
    }

});